// @flow
import React from "react"
import { rhythm } from "../utils/typography"
import { white, accent } from "../utils/colors"

type Props = {
  idx: number,
  activeIdx: number,
  company: string,
  companyLogo: string,
  viewTestimonial: (idx: number) => mixed,
}

const TestimonialTile = ({
  idx,
  activeIdx,
  company,
  companyLogo,
  viewTestimonial,
}: Props) => {
  const isActive = idx === activeIdx
  const handleClick = () => {
    // Don't track while developing.
    if (process.env.NODE_ENV === `production` && typeof ga === `function`) {
      window.ga(`send`, `event`, `Testimonial`, `click`, company)
    }
    viewTestimonial(idx)
  }
  return (
    <div
      css={[styles.tile, isActive && styles.activeTile]}
      onClick={handleClick}
    >
      <img src={companyLogo} alt={company} />
    </div>
  )
}

const styles = {
  tile: {
    display: "flex",
    alignItems: "center",
    backgroundColor: white,
    margin: rhythm(1 / 2),
    boxShadow: "0 4px 24px 0 rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    overflow: "hidden",
    border: "4px solid transparent",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 24px rgba(50,50,93,.1), 0 8px 15px rgba(0,0,0,.07)",
      cursor: "pointer",
    },
    "> img": {
      filter: "grayscale(100%)",
      marginBottom: 0,
    },
  },
  activeTile: {
    // borderColor: accent,
    transform: "translateY(-2px)",
    boxShadow: "0 8px 24px rgba(50,50,93,.1), 0 8px 15px rgba(0,0,0,.07)",
    "> img": {
      filter: "grayscale(0%)",
    },
  },
}

export default TestimonialTile



// WEBPACK FOOTER //
// ./src/components/TestimonialTile.js